import React, { ComponentType } from 'react'
import { MdLocalPhone } from 'react-icons/md'

interface Props {
  phone1: string
}

export const Phone: ComponentType<Props> = ({ phone1 }) => (
  <a href={`tel:${phone1}`} className="inversed-link font-weight-500 text-nowrap">
    <MdLocalPhone /> {phone1}
  </a>
)
